<template>
  <div>
    <div v-if="view == 'upload'" class="upload">
      <LoadingSpinner v-if="isLoading" />
      <Alerts />

      {{ /* Origin Form */}}
      <div class="card">
        <div class="card-header blue">Confirm Origin</div>
        <div class="card-body">
          <b-row>
            <b-col sm="7">
              <p class="font-weight-bold">Saved Origin Addresses</p>
              <b-form-group>
                <b-form-select
                  v-model="selected"
                  size="sm"
                  ref="originDropDown"
                  :class="['custom-dropdown']"
                  :disabled="!shipper_addresses.length"
                  :options="shipper_addresses"
                  @change="showOriginAddress"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <div class="w-100"></div>

            <b-col sm="7" class="my-3">
              Address shown will be used to process your labels. &nbsp;You can clear the form and enter a temporary return address (normal practice if you are fulfilling for a company and
              return address differs). &nbsp;If you will be using the temporary address for multiple uploads, we suggest you use the “Save Address” button. &nbsp;To edit any saved origin addresses,
              click <a href="/#/my-account#tab-origins">Origin Addresses</a> and you will be redirected.
            </b-col>

            <b-col sm="12">
              <b-btn size="sm" class="mb-3 btn-light-blue-outline" @click="clearOrigin">Clear Form</b-btn>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="7">
              <div class="mb-1">
                <a v-if="!showLongAdress" href="javascript:void(0)" @click="onShowLongAddress">
                  <img width="23" src="/images/icons/paste-button.png" style="margin-top: -3px;">
                  Click here to paste address
                </a>
              </div>
              <b-form-row v-if="showLongAdress">
                <b-col sm="12" class="mb-2">
                  <b-form-group>
                    <b-form-textarea
                      v-model="long_address"
                      placeholder="Name
Company (Optional)
Address Line 1
Address Line 2 (Optional)
City State Postal Code"
                      rows="5"
                      @change="onLongAddressChange"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form @submit.prevent="createOrigin" data-vv-scope="create-origin">
                <b-form-row>
                  <b-col sm="12" class="mb-2">
                    <b-input
                      id="company"
                      name="company"
                      type="text"
                      size="sm"
                      :class="[{'is-invalid': !(origin.company || origin.first_name || origin.last_name)}]"
                      v-model="origin.company"
                      placeholder="Company"
                    ></b-input>
                  </b-col>

                  <b-col sm="6" class="mb-2">
                    <b-input
                      id="first_name"
                      name="first_name"
                      type="text"
                      size="sm"
                      v-model="origin.first_name"
                      :class="[{'is-invalid': !(origin.company || origin.first_name || origin.last_name)}]"
                      placeholder="First Name"
                    ></b-input>
                  </b-col>

                  <b-col sm="6" class="mb-2">
                    <b-input
                      id="last_name"
                      name="last_name"
                      type="text"
                      size="sm"
                      v-model="origin.last_name"
                      :class="[{'is-invalid': !(origin.company || origin.first_name || origin.last_name)}]"
                      placeholder="Last Name"
                    ></b-input>
                  </b-col>

                  <b-col sm="12" class="mb-2">
                    <GoogleAutoComplete
                      :g-class="['form-control', 'form-control-sm', {'is-invalid': !origin.address}]"
                      v-model="origin.address"
                      placeholder="Address"
                      @change="onGoogleAddressChange"
                    ></GoogleAutoComplete>
                  </b-col>

                  <b-col sm="6" class="mb-2">
                    <zip-code-input
                      id="postal"
                      type="text"
                      size="sm"
                      class="form-control form-control-sm"
                      v-model="origin.postal"
                      :class="[{'is-invalid': !origin.postal}]"
                      placeholder="Postal Code"
                    ></zip-code-input>
                  </b-col>

                  <b-col sm="6" class="mb-2">
                    <b-input
                      id="city"
                      name="city"
                      type="text"
                      size="sm"
                      v-model="origin.city"
                      :class="[{'is-invalid': !origin.city}]"
                      placeholder="City"
                    ></b-input>
                  </b-col>

                  <b-col sm="6" class="mb-2">
                    <b-select
                      id="state"
                      type="text"
                      size="sm"
                      v-model="origin.state"
                      :class="[{'is-invalid': !origin.state}]"
                      :options="stateSelectOptions"
                      placeholder="State"
                    ></b-select>
                  </b-col>

                  <b-col sm="6" class="mb-2">
                    <b-input value="US" size="sm" disabled></b-input>
                  </b-col>

                  <b-col sm="12" class="mb-2">
                    <b-input
                      name="phone"
                      type="tel"
                      size="sm"
                      v-model="origin.phone"
                      v-mask="'(###) ###-####'"
                      placeholder="Phone Number"
                    ></b-input>
                  </b-col>

                  <b-col sm="12" class="mb-2">
                    <zip-code-input
                      id="postal-origin"
                      type="text"
                      class="form-control form-control-sm"
                      v-model="origin.postal_origin"
                      :class="[{'is-invalid': !origin.postal_origin}]"
                      placeholder="Postal Code where the packages will be processed (may differ from address above)"
                    ></zip-code-input>
                  </b-col>
                </b-form-row>

                <b-row class="mt-2">
                  <b-col>
                    <b-btn
                      @click="verifyAddress"
                      size="sm"
                      class="btn-light-blue-outline mr-2"
                    >
                      <img class="verifyImg" src="/images/icons/verify-address-blue.png">
                      Verify Address
                    </b-btn>
                    <b-btn
                      @click="saveAddress"
                      size="sm"
                      class="btn-light-blue-outline"
                    >
                      <img class="verifyImg" src="/images/icons/save-address-blue.png">
                      Save Address
                    </b-btn>
                  </b-col>
                </b-row>

              </b-form>
            </b-col>
          </b-row>
        </div>
      </div>
      {{ /* Origin Form */}}

      <div class="card">
        <div class="card-header blue">Upload File &nbsp; (Maximum records allowed per upload - 2,500)</div>
        <div class="card-body">
          <b-row>
            <b-col sm="12">
              <b-btn size="sm" @click.prevent="onClick" class="btn-light-blue-outline">
                <!-- <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" stroke="#4472c4" d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
                </svg> -->
                <img class="verifyImg" src="/images/icons/paperclip-blue.png">
                Choose CSV File
              </b-btn>
              <input type="file" ref="fileInput" class="d-none" @change="onFileChanged" accept=".csv">
              <span v-if="this.file">{{ this.file.name }}</span>
            </b-col>
          </b-row>

          <b-row class="justify-content-between px-3 mt-3">
            <b-btn class="btn-blue" size="sm" @click="$router.push('/orders/import');">
              <span class="glyphicon glyphicon-arrow-left"></span> Previous Page
            </b-btn>
            <b-btn class="btn-blue" :disabled="isInvalid" size="sm" @click="view = 'mapping'">
              Start Mapping Fields <span class="glyphicon glyphicon-arrow-right"></span>
            </b-btn>
          </b-row>
        </div>
      </div>
    </div>

    <div v-if="view == 'mapping'">
      <FieldMapping
        :view.sync="view"
        :origin="origin"
        :file="file"
        :headers="headers"
        :row="row"
      />
    </div>
  </div>
</template>

<style lang="scss">
.custom-control-label {
  &::before, &::after {
    top: 0.1rem !important;
  }
}
</style>

<style lang="scss" scoped>
textarea {
  font-size: 0.75rem !important;
  resize: none !important;
}
fieldset {
  margin-bottom: 0 !important;
}

.upload {
  position: relative;
  .card {
    font-size: 0.75rem !important;
    margin-bottom: 1.5rem;

    .card-header {
      color: #fff;
      font-size: 0.95rem !important;
      padding: 0.10rem 1rem;

      > *:not(.form-control) {
        color: #fff;
      }

      .btn {
        margin-top: 0;
        padding: 1px 8px;

        .glyphicon {
          vertical-align: center;
        }
        &.collapsed {
          .glyphicon-chevron-up {
            transform: rotate(180deg);
          }
        }
      }
    }
    .form-group {
      margin-bottom: 0.5rem;
    }
    input, select, button, label, .input-group-text {
      font-size: 0.75rem !important;
    }
    .card-body {
      min-height: 0px;
    }
    .dropdown{
      .dropdown-toggle{
        padding: 2px;
      }
    }
    .card-body, #additional-services-collapse, & {
      > table {
        margin-bottom: 0;

        tbody {
          padding-top: 10px;
        }

        td:first-child,
        th:first-child {
          padding-left: 20px;
        }

        td:last-child,
        th:last-child {
          padding-right: 20px;
        }

        td,
        th {
          padding-top: 10px;
          padding-bottom: 10px;
        }
      }
    }
    .verify-btn {
      display: flex;
      text-align: center;
      left: 0;
      right: 0;
      margin-top: -15px;
      margin-left: 15px;
      margin-right: 15px;
      margin-bottom: 10px;

      button {
        flex-basis: 50%;
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }

  .table {
    &:last-child {
      margin-bottom: 0;
    }

    th {
      padding-right: 0;
    }
    td {
      .form-group {
        margin-bottom: 0;
      }
    }
  }
}
</style>

<script>
import Papa from "papaparse";
import XLSX from "xlsx";
import { mapGetters } from "vuex";

import human from 'parse-full-name';
import parser from 'parse-address';

import states from "../../../data/states";
import formatters from "../../../formatters";
import validations from './validations'

import FieldMapping from './FieldMapping'

import LoadingSpinner from "../../../components/LoadingSpinner";
import Alerts from "../../../components/Alerts";
import GoogleAutoComplete from "../../../components/GoogleAutoComplete";

export default {
  components: {
    LoadingSpinner,
    Alerts,
    GoogleAutoComplete,
    FieldMapping
  },
  data() {
    return {
      showLongAdress: false,
      long_address: '',
      view: 'upload',
      invalidFile: false,
      file: null,
      isLoading: false,
      orderType: {
        id: 2,
        name: 'import',
      },
      headers: [],
      row: [],
      delOrigin: false,
      shipper_addresses: [],
      selected: '',
      origin: {
        default: false,
        id: null,
        name: null,
        first_name: null,
        last_name: null,
        company: null,
        address: null,
        city: null,
        state: null,
        postal: null,
        postal_origin: null,
        country: 'US',
        phone: null
      },
      shipping_label_formats: {
        selected: null,
        preview: null,
      },
    }
  },
  validations,
  computed: {
    ...mapGetters({
      user: "getUser",
      employee_name: "getEmployeeName",
    }),
    stateSelectOptions() {
      return [{text: "State", value: null}, ...states.getSelectOptions()];
    },
    isInvalid() {
      return !this.isCSV() || this.$v.validationGroup["origin"].$invalid || this.invalidFile;
    }
  },
  async mounted() {
    this.selected = this.origin;
    await axios.get("user/addresses").then(response => {
      if (response.data.length > 0) {
        const shipperAddr = response.data.map(or => {
          let full_name = `${ or.first_name || '' } ${ or.last_name || '' }`;
          if(full_name.trim() && or.company) full_name = `${ full_name }, ${ or.company }`;
          else if(!full_name.trim()) full_name = or.company;
          return {
            value: or,
            text: `${ full_name }, ${ or.address }, ${ or.city }, ${ or.state }`
          }
        });
        this.shipper_addresses = shipperAddr;

        let selected = _.find(response.data, addr => addr.is_default);

        if (this.employee_name) {
          const employee = this.user.employees.find(e => e.name === this.employee_name)
          if (employee && employee.origin_id) {
            selected = _.find(response.data, addr => addr.id === employee.origin_id)
          }
        }

        if(this.$refs.originDropDown){
          if (selected) {
            this.selected = selected;
            this.origin = selected;
          }
        }
      }
    });
  },
  methods: {
    showOriginAddress() {
      this.delOrigin = false;
      this.origin = this.selected;
    },

    clearOrigin() {
      this.origin = {
        default: false,
        id: null,
        first_name: null,
        last_name: null,
        company: null,
        address: null,
        city: null,
        state: null,
        postal: null,
        postal_origin: null,
        country: 'US',
        phone: null
      };
      this.selected = null;
    },

    onClick() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },

    async createOrigin() {
      this.$v.validationGroup["origin"].$touch();
      if (this.$v.validationGroup["origin"].$invalid) {
        return;
      }

      const tzUrl = `${process.env.MIX_INTEG_URL}/get-tz?zipcode=${this.origin.postal}`;
      const tz = await axios.get(tzUrl);
      const originData = Object.assign({}, this.origin, {timezone: tz.data || "America/New_York"})
      try{
        // const response = await axios.post("/origin", originData)
        const response = await axios.post("/origin", this.origin)
        this.$emit("alert", {
          message: response.data.message,
          type: "success"
        });
        this.$v.validationGroup["origin"].$reset();
      }catch(error){
        this.$emit("alert", {
          message: error.response.data.message,
          type: "danger"
        });
      }
    },

    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsBinaryString(file);
      });
    },

    isCSV() {
      if (this.file) return /\.csv$/i.test(this.file.name);
      return false;
    },

    async onFileChanged(e) {
      this.invalidFile = false;
      this.isLoading = true;
      this.label = [];
      this.$emit("alert_close");

      this.file = e.target.files[0];

      let content = null;

      if (!this.isCSV()) {
        await this.uploadError("Invalid format. Please provide a CSV file.")
        return;
      }

      try {
        content = await this.readFileAsync(this.file);
      } catch (e) {
        await this.uploadError("Failed to read file.")
        return;
      }

      let result = Papa.parse(content, {
        header: true,
        skipEmptyLines: "greedy",
      });
      // empty
      if (!result.data.length) {
        await this.uploadError("Invalid file: no rows present.")
        return;
      }

      if (result.data.length > 2501) {
        await this.uploadError("Unable to proceed, you've exceeded the maximum records allowed per upload.")
        return;
      }

      this.row = result.data[0];
      this.headers = Object.keys(result.data[0], k => k !== "")

      this.isLoading = false;
    },

    async uploadError(msg) {
      this.$emit("alert", {
        message: msg,
        type: "danger"
      });
      this.file = null;
      this.invalidFile = true;
      this.isLoading = false;
    },

    onGoogleAddressChange(addr){
      if (addr.country !== 'US') {
        this.$emit('alert', {
          type: 'danger',
          message: 'Only addresses from US is allowed.'
        })
      } else {
        addr.postal = addr.postal_code
        addr.postal_origin = addr.postal_code
        addr.state = addr.state || addr.province
        this.origin = Object.assign({}, this.origin, addr);
      }
    },
    onSubmit() {
      this.view = 'mapping';
    },
    onShowLongAddress() {
      this.showLongAdress = true;
    },
    onLongAddressChange(val) {
      if (val) {
        this.parseAddress(val);
      } else {
        this.onClearItems();
      }
    },
    onClearItems() {
      this.origin = {
        company: '',
        first_name: '',
        last_name: '',
        state: null,
        province: '',
        city: '',
        address: '',
        address2: '',
        postal: '',
        postal_origin: '',
        country: 'US',
      }
      this.long_address = ''
    },
    async parseAddress(long_address) {
      let address = long_address.split(/\r?\n/).map(a => a.trim()).filter(a => a.length > 0);

      if (address.length === 1) {
        address = long_address.split(/,/).map(a => a.trim()).filter(a => a.length > 0);
        this.long_address = address.join('\r\n');
      }

      if (address.length > 2) {
        this.isLoading = true;
        // check if country is on the last element then remove
        if (['us', 'usa', 'america', 'united states', 'united states of america'].includes(address[address.length - 1].trim().toLowerCase())) {
          address.pop();
        }

        // parse name (Expecting that the first row is name)
        let first = address.shift();
        let parsedName = human.parseFullName(first);

        // if address doesn't have number, move it to company
        let second = address[0];
        let company = '';

        const re = /\d/;
        if (!re.test(second)) {
          company = second;
          address.shift();
        }

        // address parser
        const parsedAddress = parser.parseLocation(address.join(' '));
        const postal_code = parsedAddress.plus4 ? `${parsedAddress.zip}-${parsedAddress.plus4}` : parsedAddress.zip

        if (!postal_code) {
          this.isLoading = false;
          this.$emit('alert', {
            message: 'Postal code is required.',
            type: 'danger'
          });
        } else {
          // get city state from ziptastic api
          const city_state = await this.getCityState(postal_code);

          let data = {
            company: company,
            first_name: parsedName.first,
            last_name: parsedName.last,
            state: city_state.state,  // new shipment uses province
            province: city_state.province,
            city: city_state.city,
            address: address[0],
            address2: address.length > 2 ? address[1] : '',
            postal: postal_code,
            postal_origin: postal_code,
            country: 'US',
          }

          this.origin = Object.assign({}, this.origin, data)
        }
      }
    },
    async getCityState(zip) {
      this.isLoading = true;

      let url = "https://zip.getziptastic.com/v2/US/" + zip;
      var axiosCrossDomain = axios;
      delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];
      delete axiosCrossDomain.defaults.headers.common["X-Requested-With"];

      try {
        const { data } = await axiosCrossDomain(url, { method: "GET" });
        const pattern = /^(APO|FPO|DPO)\s(AE|AA|AP)$/
        let {state_short, city, country} = data;

        if(pattern.test(city.toUpperCase())){
          const [c,s] = city.split(" ");
          state_short = s;
          city = c;
        }

        this.origin.city = city;
        this.origin.province = state_short;
        this.origin.state = state_short;
        // this.origin.country = country;

        return {
          city: city,
          province: state_short,
          state: state_short,
        }
      } catch(error) {
        console.log('City State Error: ', error);
      } finally {
        this.isLoading = false;
      }
    },
    onShowLongAddress() {
      this.showLongAdress = true;
    },
    verifyAddress() {
      let address = formatters.address.toPb(this.origin);
      this.isLoading = true;
      axios
        .post("/verify", { address: address })
        .then(response => {
          this.isLoading = false;

          this.$emit("alert", {
            message: this.$t("alerts.address.valid"),
            type: "success"
          });

          let address = response.data;

          if (
            address &&
            (address.status === "VALIDATED_CHANGED" ||
              address.status === "VALIDATED_AND_NOT_CHANGED")
          ) {
            // Mass-assign to not delete name
            address = formatters.address.fromPb(address);
            this.origin = Object.assign({}, this.origin, address);
          }
        })
        .catch(e => {
          this.isLoading = false;
          this.$emit("alert", {
            message:
              address.countryCode === "US"
                ? "Address could not be verified. Please double check address to avoid delay or undeliverable. You may still proceed to print label."
                : "Sorry, address verification is only for U.S. addresses",
            type: "danger"
          });
        });
    },

    saveAddress(e) {
      e.preventDefault();
      this.isLoading = true;
      // console.log('save address toAddress: ', this.toAddress);
      axios
        .post("/addresses", Object.assign({}, this.toAddress, {acct_id: this.acct_id}))
        .then(resp => {
          this.$emit("alert", {
            message: resp.data.message || "Address saved!",
            type: "success"
          });
        })
        .catch(error => {
          this.$emit("alert", {
            message: formatters.errors.comma(error.response.data.errors),
            type: "danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Import/Upload.vue